<template>
  <div>
    <div class="mx-auto">
      <NavBarMobileMenu v-if="showMenu" @close:menu="showMenu = false" />
      <NavBar :menu-open="showMenu" @open:menu="showMenu = true" />
      <main id="main-content" class="default-content mx-4 lg:mx-20" tabindex="-1">
        <div class="max-w-7xl mx-auto">
          <slot />
        </div>
      </main>
      <Footer :show-newsletter="showNewsletter" />
    </div>
  </div>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ showNewsletter?: boolean }>(), { showNewsletter: true })
const showMenu = ref(false)

defineOgImage({
  component: 'OgImageDefault',
  title: 'Filip Hric'
})

useHead({
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'I teach testers about web development and developers about testing. Blog about Cypress.io full of articles courses and workshops'
    }
  ]
})

</script>
